<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import committeeQuarterlyReportAPI from "@/services/standards/committee/committeeQuarterlyReportAPI";
import Swal from "sweetalert2";

const TRIMESTRES = {
  1: "I (Ene–Mar)",
  2: "II (Abr–Jun)",
  3: "III (Jul–Sep)",
  4: "IV (Oct–Dic)",
};

/**
 * 1.1.8 — Listado de informes trimestrales del Comité de Convivencia (para entrega a la gerencia).
 */
export default {
  page: { title: "Informe trimestral — Comité de Convivencia" },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "1.1.8 Informe trimestral del Comité de Convivencia",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        {
          text: "1.1.8 Comité de convivencia",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null}/conformacion-comite-convivencia`,
        },
        { text: "Informe trimestral", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      lista: [],
      loading: true,
    };
  },
  methods: {
    trimestre(q) {
      return TRIMESTRES[q] || q;
    },
    getList() {
      committeeQuarterlyReportAPI.index(this.companyID)
        .then((r) => {
          this.lista = (r && r.List && r.List.data) ? r.List.data : [];
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    nuevo() {
      this.$router.push({ path: "/forms/estandares/informe-trimestral-convivencia-editar" });
    },
    editar(id) {
      this.$router.push({ path: `/forms/estandares/informe-trimestral-convivencia-editar/${id}` });
    },
    descargarPdf(id) {
      window.open(committeeQuarterlyReportAPI.pdfUrl(id));
    },
    eliminar(id) {
      Swal.fire({
        title: "¿Eliminar este informe?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((r) => {
        if (!r.isConfirmed) return;
        committeeQuarterlyReportAPI.delete(id).then(() => {
          Swal.fire("Eliminado", "El informe fue eliminado.", "success");
          this.getList();
        });
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-8">
                <p class="text-muted mb-0">
                  Genera el informe trimestral con la gestión del comité (reuniones, quejas, actividades
                  y recomendaciones) para entregar a la gerencia. Es editable y produce un PDF con el
                  formato oficial de la empresa.
                </p>
              </div>
              <div class="col-4 text-right">
                <button class="btn btn-secondary mr-1" @click="goBack"><i class="fas fa-arrow-left"></i></button>
                <button class="btn btn-primary" @click="nuevo"><i class="mdi mdi-plus"></i> Nuevo informe</button>
              </div>
            </div>

            <div v-if="loading" class="text-center py-4"><b-spinner variant="primary" /></div>

            <div v-else class="table-responsive">
              <table class="table table-striped border-bottom">
                <thead>
                  <tr>
                    <th class="text-center">Año</th>
                    <th class="text-center">Trimestre</th>
                    <th class="text-center">Fecha</th>
                    <th class="text-center">Responsable</th>
                    <th class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in lista" :key="r.id">
                    <td class="text-center align-middle">{{ r.year }}</td>
                    <td class="text-center align-middle">{{ trimestre(r.quarter) }}</td>
                    <td class="text-center align-middle">{{ r.fecha ? r.fecha.substring(0, 10) : "—" }}</td>
                    <td class="text-center align-middle">{{ r.responsable || "—" }}</td>
                    <td class="text-center align-middle">
                      <b-dropdown variant="primary" size="sm">
                        <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                        <b-dropdown-item @click="editar(r.id)">Editar</b-dropdown-item>
                        <b-dropdown-item @click="descargarPdf(r.id)">Descargar PDF</b-dropdown-item>
                        <b-dropdown-item @click="eliminar(r.id)">Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                  <tr v-if="!lista.length">
                    <td colspan="5" class="text-center text-muted py-3">Aún no hay informes registrados.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
